type AppConfig = {
  apiBaseUrl: string;
  stage: string;
  googleAnalyticsId?: string;
};

export const appConfig: AppConfig = {
  apiBaseUrl:
    import.meta.env.VITE_USE_LOCAL_API === "true"
      ? "http://localhost:1337"
      : import.meta.env.VITE_API_URL,
  stage: import.meta.env.VITE_APP_STAGE || "local",
  googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
};

if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.log(appConfig);
}
